import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

const initialState = {
  emailActions: [],
  totalEmailActions: 0,
  placeholders: [],
  selectAllField: false,
  selectedEmailActions: []
}

export default {
  namespaced: true,

  state: initialState,

  getters: getters,

  actions: actions,

  mutations: mutations
}
